import React, { AnchorHTMLAttributes, ImgHTMLAttributes } from 'react';
import './Image.css';

export interface IImageProps
	extends ImgHTMLAttributes<any>,
		AnchorHTMLAttributes<any> {
	grayscale?: boolean;
	target?: TAnchorTarget;
}

const Image = ({
	grayscale,
	href,
	className,
	src,
	alt = 'Image',
	target,
	...rest
}: IImageProps) => {
	const formattedClassName = `Image${grayscale ? '__grayscale' : ''} ${
		className || ''
	}`;

	if (href) {
		return (
			<a className='Image__link text-grey-tundora no-underline' href={href} target={target}>
				<img
					className={formattedClassName}
					src={src}
					alt={alt}
					{...rest}
				/>
			</a>
		);
	}

	return <img className={formattedClassName} src={src} alt={alt} {...rest} />;
};

export default Image;
